<template>
  <div class="Footermobile">
    <a href="/m-dist/index.html#">切换手机版</a>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.Footermobile {
  border-top: 1px solid #ccc;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #212121;
  // text-decoration: none;
  a {
    display: block;
    text-decoration: none;
    color: #ccc;
    cursor: pointer;
  }
}
</style>
